<div class="lum-c-accounting  lum-page">
  <div class="lum-page-header lum-page-header--sticky lum-page-header--card">
    <h2 class="lum-page-header__heading">Accounting Dashboard</h2>
    <div
      *ngIf="'utah-UTAH-363-accounting_dashboard' | featureFlag"
      class="lum-page-header__actions"
    >
      <button
        type="button"
        class="lum-button lum-button--secondary lum-button--large"
        [disabled]="form.invalid || submittingForm"
        (click)="onSubmit()"
      >
        <lum-ui-icon
          color="currentColor"
          width="12"
          height="12"
          icon="download-button"
        ></lum-ui-icon>
        Export
      </button>
    </div>
  </div>
  <div
    *ngIf="'utah-UTAH-363-accounting_dashboard' | featureFlag; else whenFlagOff"
    class="lum-page-content"
  >
    <div class="lum-page__card">
      <form [formGroup]="form">
        <label class="form-group  mb-0  d-flex align-center gap-x-4 flex-wrap">
          <div class="lum-label  mb-0  w-max-content">
            <span class="h6">Date Range:</span>
          </div>
          <mat-form-field
            class="lum-input lum-input--daterange  py-0 w-80"
            [ngClass]="{ 'has-error': form.invalid }"
          >
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate formControlName="fromDate" />
              <input matEndDate formControlName="endDate" />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="rangePicker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker></mat-date-range-picker>
          </mat-form-field>
          <mat-error *ngIf="form.hasError('exceedsThreeMonths')">
            <small>
              The difference between the start and end date must be within 3 months.
            </small>
          </mat-error>
        </label>
      </form>
    </div>

    <section class="lum-page__card  pb-1">
      <header class="mb-6">
        <h4>Financial Snapshot</h4>
      </header>
      <div class="row">
        <div class="col">
          <div class="lum-tile lum-tile--success">
            <h6 class="lum-label">Total Revenue</h6>
            <div class="h3">$1,000,000</div>
          </div>
        </div>
        <div class="col">
          <div class="lum-tile lum-tile--neutral">
            <h6 class="lum-label">Total COGS</h6>
            <div class="h3">$500,000</div>
          </div>
        </div>
        <div class="col">
          <div class="lum-tile lum-tile--info">
            <h6 class="lum-label">Gross Profit</h6>
            <div class="h3">$500,000</div>
          </div>
        </div>
        <div class="col">
          <div class="lum-tile lum-tile--primary">
            <h6 class="lum-label">Gross Margin</h6>
            <div class="h3">50%</div>
          </div>
        </div>
      </div>
    </section>

    <section class="lum-page__card  pb-1">
      <header class="mb-6">
        <h4>Sales & Channel Performance</h4>
      </header>
      <div class="row">
        <div class="col">
          <div class="lum-tile lum-tile--neutral">
            <h6 class="lum-label">Total Net Revenue</h6>
            <div class="h3">$1,000,000</div>
          </div>
        </div>
        <div class="col">
          <div class="lum-tile lum-tile--neutral">
            <h6 class="lum-label">Sales Count</h6>
            <div class="h3">120,000</div>
          </div>
        </div>
        <div class="col">
          <div class="lum-tile lum-tile--neutral">
            <h6 class="lum-label">Units Sold</h6>
            <div class="h3">200,000</div>
          </div>
        </div>
        <div class="col">
          <div class="lum-tile lum-tile--neutral">
            <h6 class="lum-label">AOV</h6>
            <div class="h3">$5.00</div>
          </div>
        </div>
      </div>
      <section>
        <h5 class="mt-4 mb-4">Sales by Channel</h5>
        <div class="lum-c-accounting__channels">
          <div class="lum-c-accounting__channels-list">
            <section
              *ngFor="let channel of DUMMY_CHANNELS; let i = index"
              class="lum-tile lum-tile--border  lum-c-accounting__channel"
              [class.is-highlighted]="channel.isHighlighted"
              [style.--identity-color]="CHART_COLORS[i]"
              (pointerenter)="channel.isHighlighted = true"
              (pointerleave)="channel.isHighlighted = false"
            >
              <h6 class="h4  mt-1">{{ channel.name }}</h6>
              <div class="h4  text-right">{{ channel.revenue | currency }}</div>
              <div class="lum-label  order-4  mb-0 text-right">
                {{ channel.percentage }}% of total
              </div>
              <dl class="dl-inline  d-flex gap-x-2">
                <div class="mr-auto">
                  <dt>Sales:</dt>
                  <dd>{{ channel.sales }}</dd>
                </div>
                <div class="mr-auto">
                  <dt>Units:</dt>
                  <dd>{{ channel.units }}</dd>
                </div>
                <div class="mr-auto">
                  <dt>AOV:</dt>
                  <dd>{{ channel.aov | currency }}</dd>
                </div>
              </dl>
            </section>
          </div>
          <div class="mb-4">
            <div class="lum-c-accounting__channels-chart" role="presentation">
              <div
                *ngFor="let channel of DUMMY_CHANNELS; let i = index"
                class="lum-c-accounting__channels-bar"
                [class.is-highlighted]="channel.isHighlighted"
                [style.--identity-color]="CHART_COLORS[i]"
                [style.height]="'' + channel.percentage + '%'"
                [title]="'' + channel.percentage + '%'"
                (pointerenter)="channel.isHighlighted = true"
                (pointerleave)="channel.isHighlighted = false"
              ></div>
            </div>
          </div>
        </div>
      </section>
      <div class="row">
        <section class="col-sm">
          <h5 class="mb-4">Returns & Refunds</h5>
          <div class="lum-tile lum-tile--danger  d-flex justify-content-between">
            <div>
              <h6 class="lum-label">Returns</h6>
              <div class="h3">2280 (1.9%)</div>
            </div>
            <div class="text-right">
              <h6 class="lum-label">Returned COGS</h6>
              <div class="h3">$24,800</div>
            </div>
          </div>
          <div class="lum-tile lum-tile--danger">
            <h6 class="lum-label">Refunds</h6>
            <div class="h3">$32,860 (3.3%)</div>
          </div>
        </section>
        <section class="col-sm">
          <h5 class="mb-4">Promotions Impact</h5>
          <div class="lum-tile lum-tile--warning">
            <h6 class="lum-label">Discounts</h6>
            <div class="h3">$43,000</div>
          </div>
          <div class="lum-tile lum-tile--success">
            <h6 class="lum-label">Promo Spend ROAS</h6>
            <div class="h3">3.7x</div>
          </div>
        </section>
      </div>
    </section>

    <section class="lum-page__card  pb-1">
      <header class="mb-6">
        <h4>Inventory & Fulfillment</h4>
      </header>
      <div class="row">
        <section class="col">
          <h5 class="mb-4">Inventory Valuation</h5>
          <div class="lum-tile lum-tile--info">
            <h6 class="lum-label">Ending Inventory</h6>
            <div class="h3">$325,000</div>
          </div>
          <div class="lum-tile lum-tile--success">
            <h6 class="lum-label">Inventory Turnover</h6>
            <div class="h3">4.20x</div>
          </div>
          <div class="lum-tile lum-tile--danger">
            <h6 class="lum-label">Deadstock Value</h6>
            <div class="h3">$12,000</div>
          </div>
        </section>
        <section class="col">
          <h5 class="mb-4">Fulfillment Metrics</h5>
          <div class="row">
            <div class="col">
              <div class="lum-tile lum-tile--neutral  text-center">
                <h6 class="lum-label">Orders Shipped</h6>
                <div class="h3">21,000</div>
              </div>
            </div>
            <div class="col">
              <div class="lum-tile lum-tile--warning  text-center">
                <h6 class="lum-label">Unfulfilled Orders</h6>
                <div class="h3">142</div>
              </div>
            </div>
          </div>
          <div class="lum-tile lum-tile--primary">
            <h6 class="lum-label">Avg Shipping Cost</h6>
            <div class="h3">$8</div>
          </div>
          <div class="lum-tile lum-tile--success">
            <h6 class="lum-label">Avg Fulfillment Time</h6>
            <div class="h3">3.2 days</div>
          </div>
        </section>
      </div>
      <section>
        <h5 class="mt-4">Reconciliation (On-Hand)</h5>
        <p class="text-muted">
          <em>
            <strong>Formula:</strong> Starting Value - COGS Value + Receipts Value +
            Adjustments Value = Ending Value
          </em>
        </p>
        <div class="row  mt-4">
          <div class="col">
            <div class="lum-tile lum-tile--primary">
              <h6 class="lum-label">Starting Value</h6>
              <div class="h3">$275,000</div>
            </div>
          </div>
          <div class="col">
            <div class="lum-tile lum-tile--danger">
              <h6 class="lum-label">COGS Value</h6>
              <div class="h3">-$580,000</div>
            </div>
          </div>
          <div class="col">
            <div class="lum-tile lum-tile--success">
              <h6 class="lum-label">Receipts Value</h6>
              <div class="h3">+$642,000</div>
            </div>
          </div>
          <div class="col">
            <div class="lum-tile lum-tile--danger">
              <h6 class="lum-label">Adjustments Value</h6>
              <div class="h3">-$12,000</div>
            </div>
          </div>
          <div class="col">
            <div class="lum-tile lum-tile--success">
              <h6 class="lum-label">Ending Value</h6>
              <div class="h3">$325,000</div>
            </div>
          </div>
          <div class="col">
            <div class="lum-tile lum-tile--neutral">
              <h6 class="lum-label">Calculated</h6>
              <div class="h3">$325,000</div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
  <ng-template #whenFlagOff>
    <div class="lum-page-content">
      <form [formGroup]="form" class="lum-page__card">
        <div class="flex align-center gap-7">
          <div class="block w-100">
            <div>From Date</div>
            <div>
              <input
                formControlName="fromDate"
                type="date"
                required="true"
                class="lum-input"
              />
              <mat-error *ngIf="form.get('fromDate')?.invalid">
                <small>
                  {{ form.get('fromDate') | validateField }}
                </small>
              </mat-error>
            </div>
          </div>
          <div class="block w-100">
            <div>End Date</div>
            <div>
              <input
                formControlName="endDate"
                type="date"
                required="true"
                class="lum-input"
              />
              <mat-error *ngIf="form.get('endDate')?.invalid">
                <small>
                  {{ form.get('endDate') | validateField }}
                </small>
              </mat-error>
            </div>
          </div>
        </div>
        <div class="flex align-center gap-7">
          <mat-error *ngIf="form.hasError('exceedsThreeMonths')">
            <small>
              The difference between the start and end date must be within 3 months.
            </small>
          </mat-error>
        </div>
        <div class="mt-4">
          <div class="flex ml-auto gap-2">
            <button
              type="button"
              class="lum-button lum-button--primary lum-button--large"
              mat-button
              [disabled]="form.invalid || submittingForm"
              (click)="onSubmit()"
            >
              <lum-ui-icon
                color="#ffffff"
                width="12"
                height="12"
                class="mr-2"
                icon="download-button"
              ></lum-ui-icon>
              Export
            </button>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <div
    class="overlay"
    lumAppLoader
    [loading]="submittingForm || false"
    [classes]="'loading blur'"
  ></div>

  <ng-template #inputLoader>
    <div class="lum-input">
      <mat-spinner class="ml-auto" [diameter]="16"></mat-spinner>
    </div>
  </ng-template>
</div>
